const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  return {
    id: snap.id,
    ...snap.data()
  };
};

function ChannelCampaignsMixin() {
  return {
    async getAllChannelCampaigns() {
      return await this.collection("channel_campaigns").get().then(populateSnapshots);
    },

    async getAllChannelCampaignsWithNoOrgaId(orgaId) {
      return await this.collection("channel_campaigns")
        .where("orgaId", "!==", orgaId)
        .get()
        .then(populateSnapshots);
    },

    async getChannelCampaigns(whereRules) {
      const query = whereRules.reduce((query, rule) => {
        const [prop, operator, value] = rule;
        return query.where(prop, operator, value);
      }, this.collection("channel_campaigns"));
      return query.get().then(populateSnapshots);
    },
    async createChannelCampaign(data) {
      const ref = await this.collection("channel_campaigns").add(data);
      const channelCampaign = {
        id: ref.id,
        ...data
      };
      return channelCampaign;
    },
    async deleteChannelCampaignsById(channelCampaignIds) {
      const batch = this.batch();
      channelCampaignIds.forEach((id) => {
        const ref = this.collection("channel_campaigns").doc(id);
        batch.delete(ref);
      });
      await batch.commit();
    },
    async updateChannelCampaign(channelCampaignId, data) {
      return await this.collection("channel_campaigns")
        .doc(channelCampaignId)
        .set(data, { merge: true });
    },
    async updateChannelCampaignByCampaignIdAndChannels({ campaignId, channels, newData }) {
      const channelCampaigns = await this.collection("channel_campaigns")
        .where("campaignId", "==", campaignId)
        .where("channel", "in", channels)
        .get();

      const batch = this.collection("channel_campaigns").firestore.batch();
      channelCampaigns.docs.forEach((doc) => {
        batch.set(doc.ref, newData, { merge: true });
      });

      return batch.commit();
    },
    async updateChannelCampaignByPlatformCampaignId({ platformCampaignId, newData }) {
      const channelCampaigns = await this.collection("channel_campaigns")
        .where("platformCampaignId", "==", platformCampaignId)
        .get();

      const batch = this.collection("channel_campaigns").firestore.batch();
      channelCampaigns.docs.forEach((doc) => {
        batch.set(doc.ref, newData, { merge: true });
      });

      return batch.commit();
    },
    async fetchChannelCampaignsByCampaignIdAndChannels(campaignId, channels) {
      return await this.collection("channel_campaigns")
        .where("campaignId", "==", campaignId)
        .where("channel", "in", channels)
        .get()
        .then(populateSnapshots);
    },
    async fetchChannelCampaignsByCampaignIdChannelAndPlatformId(
      campaignId,
      channel,
      platformCampaignId
    ) {
      return await this.collection("channel_campaigns")
        .where("campaignId", "==", campaignId)
        .where("channel", "==", channel)
        .where("platformCampaignId", "==", platformCampaignId)
        .get()
        .then(populateSnapshots);
    },
    async fetchChannelCampaignsByPlatformCampaignId(platformCampaignId) {
      return await this.collection("channel_campaigns")
        .where("platformCampaignId", "==", platformCampaignId)
        .get()
        .then(populateSnapshots);
    },
    async fetchChannelCampaignsByPlatformAdsetId(platformAdGroupId) {
      return await this.collection("channel_campaigns")
        .where("platformAdsetId", "==", platformAdGroupId)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignsByAdsetIdAndChannel(adsetId, channel) {
      return await this.collection("channel_campaigns")
        .where("adsetId", "==", adsetId)
        .where("channel", "==", channel)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignsByAdsetIdAndChannels(adsetId, channels) {
      return await this.collection("channel_campaigns")
        .where("adsetId", "==", adsetId)
        .where("channel", "in", channels)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignsByAdsetId(adsetId) {
      return await this.collection("channel_campaigns")
        .where("adsetId", "==", adsetId)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignsByCampaignId(campaignId) {
      return await this.collection("channel_campaigns")
        .where("campaignId", "==", campaignId)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignsByCampaignIdAndOrgaId(campaignId, orgaId) {
      return await this.collection("channel_campaigns")
        .where("campaignId", "==", campaignId)
        .where("orgaId", "==", orgaId)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignsByCampaignIdAndChannelName(campaignId, channelName) {
      return await this.collection("channel_campaigns")
        .where("campaignId", "==", campaignId)
        .where("channel", "==", channelName)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignsByPlatformCampaignIdAndChannel(campaignId, channel) {
      return await this.collection("channel_campaigns")
        .where("platformCampaignId", "==", campaignId)
        .where("channel", "==", channel)
        .get()
        .then(populateSnapshots);
    },
    async getChannelCampaignById(channelCampaignId) {
      return await this.collection("channel_campaigns")
        .doc(channelCampaignId)
        .get()
        .then(extractSnapshotData);
    },
    async getRejectedChannelCampaigns() {
      return await this.collection("channel_campaigns")
        .where("isRejected", "==", true)
        .get()
        .then(populateSnapshots);
    }
  };
}

module.exports = ChannelCampaignsMixin;
